 /** store items */
 export const saveItem  = (key, value) => {
    return new Promise (() => {
        localStorage.setItem(key, value);
    })
 }


export const getItem = (key) => {
    return new Promise ((resolve, reject) => {
       const item = localStorage.getItem(key);
       if (item) {
        resolve(item);
       }else{
        reject({error:"Failed"});
       }
    })
}

export const removeItem = (key) => {
    localStorage.removeItem(key);
}